import React from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  matchPath,
  Outlet,
  Route,
  RouterProvider,
  useLocation,
} from 'react-router-dom'
import { ConnectorSetupSuccessPage } from './ConnectorSetupSuccess'
import { HomePage } from './Home'
import { RoutePage } from './Route/Route'
import { AuthRedirect, Forgot, Login, Register, Reset } from './Auth'
import { Header } from '@/components/ui/Header'
import Dashboard from '@/app/routes/Dashboard'
import { RequireAuth } from '@/features/auth'
import { AutoTemplateRoute } from '@/app/routes/AutoTemplateRoute'
import { Templates } from '@/app/routes/Templates'
import { TemplateRoute } from '@/app/routes/TemplateRoute'
import ErrorPage from '@/app/routes/ErrorPage/ErrorPage'

function Layaout() {
  const { pathname } = useLocation()
  const shouldShowHeader =
    !matchPath('/projects/:projectId/:routeId', pathname) && !matchPath('/templates/routes/:templateId', pathname)

  return (
    <>
      <AuthRedirect />
      {shouldShowHeader && <Header />}
      {<Outlet />}
    </>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path={'/'} element={<Layaout />} errorElement={<ErrorPage />}>
      <Route path="*" element={<ErrorPage />} />
      <Route path="/" element={<HomePage />} />
      <Route element={<RequireAuth />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/projects/:projectId/:routeId" element={<RoutePage />} />
        <Route path="/routes/new" element={<AutoTemplateRoute />} />
        <Route path="/templates/routes" element={<Templates />} />
        <Route path="/templates/routes/:templateId" element={<TemplateRoute />} />
      </Route>
      <Route path="/auth/login" element={<Login />} />
      <Route path="/auth/register" element={<Register />} />
      <Route path="/auth/forgot-password" element={<Forgot />} />
      <Route path="/auth/reset-password" element={<Reset />} />
      <Route path="/connector-setup-success" element={<ConnectorSetupSuccessPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Route>
  )
)

export function StudioRouter() {
  return <RouterProvider router={router} />
}
